import { EthernetIcon } from '../data-icons'

const DefrouteBubble = ({ isOffline }: { isOffline: boolean }) => {
  const offlineText = isOffline ? ' (Offline)' : ''
  const ariaLabel = 'Connected to Ethernet'

  return <EthernetIcon isOffline={isOffline} aria-label={`${ariaLabel}${offlineText}`} />
}

export default DefrouteBubble
